import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate } from '@angular/router';
import { ACTION_TYPE, AUTH } from 'src/app/constant/constant';
import { DANH_MUC_CHUC_DANH } from 'src/app/data/service/config.service';
import { AuthenticationService } from 'src/app/data/service/master/authentication.service';
import { DomainContextService } from 'src/app/core/service/domain-context.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        private authService: AuthenticationService,
        private router: Router,
        private domainContext: DomainContextService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (state.url == "/dang-nhap") {
            return true;
        }
        if (this.authService.isLoggedIn() ) {
            if (state.url == "/") {
                this.getDefaultRouter();
            } else {
                var data = route.data;
                if (data && data.code) {
                    var info = localStorage.getItem(AUTH.USER_INFO_KEY);
                    if (info) {
                        var user = JSON.parse(info);
                        if (user.phanQuyenChucDanh && user.phanQuyenChucDanh.length > 0) {
                            var permisstion = user.phanQuyenChucDanh.filter(item => item.ScreenId == data.code
                                && item.ActionTypeId == ACTION_TYPE.ACCESS
                                && item.Authority == true);
                            if (permisstion.length == 0) {
                                this.router.navigate(["error", "insufficient-permission"]);
                                return false;
                            }
                        }
                    }
                }
            }
            return true;
        }
        else {
            this.router.navigate(['/dang-nhap']);
            return false;
        }
        return false;
    }

    reloadComponent() {
      let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
    }

    getDefaultRouter() {
      var store = localStorage.getItem(AUTH.USER_INFO_KEY);
      if (store) {
        this.router.navigate(this.domainContext.getDefaultRoute()).then(() => {
            window.location.reload();
        });
      }
  }

    match(roleUser: any[], role) {
        let countSubmenu = 0;
        roleUser.forEach(roU => {
            if (role === roU.KY_HIEU) {
                countSubmenu = countSubmenu + 1;
            }
        });
        if (countSubmenu > 0) {
            return true;
        } else {
            return false;
        }
    }

    // isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    //   return new Promise((resolve, reject) => {

    //     if (!this.authenticated) {
    //       this.keycloakAngular.login().catch(e => console.error(e));
    //       return reject(false);
    //     }

    //     const hasRoles: string[] = route.data.roles;
    //     const hasAnyRoles: string[] = route.data.anyRoles;
    //     if (hasRoles && hasRoles.length > 0) {
    //       if (!this.roles || this.roles.length === 0) {
    //         this.router.navigate([environment.insufficientPermissionRouterLink]);
    //         return resolve(false);
    //       }
    //       if (hasRoles.every(role => this.roles.indexOf(role) > -1)) {
    //         return resolve(true);
    //       }
    //       this.router.navigate([environment.insufficientPermissionRouterLink]);
    //       return resolve(false);
    //     }

    //     if (hasAnyRoles && hasAnyRoles.length > 0) {
    //       if (!this.roles || this.roles.length === 0) {
    //         this.router.navigate([environment.insufficientPermissionRouterLink]);
    //         return resolve(false);
    //       }
    //       if (hasAnyRoles.some(role => this.roles.indexOf(role) > -1)) {
    //         return resolve(true);
    //       }
    //       this.router.navigate([environment.insufficientPermissionRouterLink]);
    //       return resolve(false);
    //     }
    //     return resolve(true);
    //   });
    // }

}
